import {
  InfoPanelTitle,
  InfoPanelDescription,
  InfoPanelLinks,
  InfoPanelFooter,
} from '@/features/jobs/details/tax-type/tax-prep-organizer/components/InfoPanel'

export function QualifiedJointVentureInfoContent() {
  return (
    <>
      <InfoPanelTitle>What is a qualified joint venture?</InfoPanelTitle>
      <InfoPanelDescription>
        <p>
          A qualified joint venture is an option you can use only if you and
          your spouse jointly own and operate a rental without creating a
          business partnership. This lets each of you report your share of
          income and expenses separately on your tax return.
        </p>
      </InfoPanelDescription>
      <InfoPanelFooter>
        <InfoPanelLinks
          links={[
            {
              label: 'Instructions for Schedule SE (Form 1040)',
              url: 'https://www.irs.gov/pub/irs-pdf/i1040sse.pdf',
            },
          ]}
        />
      </InfoPanelFooter>
    </>
  )
}
